export default {
  CHANGE_SPOT_COLOR: 'upload/CHANGE_SPOT_COLOR',
  REMOVE_SPOT_COLOR: 'upload/REMOVE_SPOT_COLOR',
  ADD_SPOT_COLOR: 'upload/ADD_SPOT_COLOR',
  INVALID_FILE: 'upload/INVALID_FILE',
  TOGGLE_PRODUCT_COLORS: 'upload/TOGGLE_PRODUCT_COLORS',
  RESET_PROGRESS: 'upload/RESET_PROGRESS',
  RESET_UPLOAD: 'upload/RESET_UPLOAD',
  UPDATE_COLOR_MODE: 'upload/UPDATE_COLOR_MODE',
  UPDATE_LAST_UPLOAD: 'upload/UPDATE_LAST_UPLOAD',
  UPLOAD_COMPLETE: 'upload/UPLOAD_COMPLETE',
  UPLOAD_FAILED: 'upload/UPLOAD_FAILED',
  UPLOAD_IN_PROGRESS: 'upload/UPLOAD_IN_PROGRESS',
  UPLOAD_SUCCESS: 'upload/UPLOAD_SUCCESS',
  UPLOAD_AND_SWAP: 'upload/UPLOAD_AND_SWAP',
  ADD_RECENT_UPLOAD: 'upload/ADD_RECENT_UPLOAD'
};
